import { defaultIconProps, IconProps } from 'components/Icons/IconProps';

export const IconObjectTrack: React.FC<IconProps> = ({ size, color, strokeWidth, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M6.66667 2.5H5.16667C4.23325 2.5 3.76654 2.5 3.41002 2.68166C3.09641 2.84144 2.84144 3.09641 2.68166 3.41002C2.5 3.76654 2.5 4.23325 2.5 5.16667V6.66667M6.66667 17.5H5.16667C4.23325 17.5 3.76654 17.5 3.41002 17.3183C3.09641 17.1586 2.84144 16.9036 2.68166 16.59C2.5 16.2335 2.5 15.7668 2.5 14.8333V13.3333M17.5 6.66667V5.16667C17.5 4.23325 17.5 3.76654 17.3183 3.41002C17.1586 3.09641 16.9036 2.84144 16.59 2.68166C16.2335 2.5 15.7668 2.5 14.8333 2.5H13.3333M17.5 13.3333V14.8333C17.5 15.7668 17.5 16.2335 17.3183 16.59C17.1586 16.9036 16.9036 17.1586 16.59 17.3183C16.2335 17.5 15.7668 17.5 14.8333 17.5H13.3333"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M6.1875 13.75L6.1875 6.25" stroke={color} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M9.578 6.32157L13.5155 9.51141C13.5881 9.57038 13.6467 9.64481 13.6869 9.72928C13.7272 9.81375 13.748 9.90613 13.748 9.9997C13.748 10.0933 13.7272 10.1856 13.6869 10.2701C13.6467 10.3546 13.5881 10.429 13.5155 10.488L9.578 13.6794C9.53165 13.7169 9.47563 13.7406 9.41639 13.7477C9.35715 13.7548 9.29711 13.745 9.2432 13.7195C9.1893 13.6939 9.14372 13.6536 9.11172 13.6032C9.07973 13.5529 9.06262 13.4945 9.06238 13.4349L9.06238 6.5661C9.06262 6.50644 9.07973 6.44806 9.11172 6.3977C9.14372 6.34735 9.1893 6.30706 9.2432 6.2815C9.29711 6.25593 9.35715 6.24613 9.41639 6.25322C9.47563 6.26031 9.53165 6.284 9.578 6.32157Z"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconObjectTrack.defaultProps = defaultIconProps;
